import { render, staticRenderFns } from "./CreateDialogModal.vue?vue&type=template&id=d6dc05b4&scoped=true"
import script from "./CreateDialogModal.vue?vue&type=script&lang=js"
export * from "./CreateDialogModal.vue?vue&type=script&lang=js"
import style0 from "./CreateDialogModal.vue?vue&type=style&index=0&id=d6dc05b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6dc05b4",
  null
  
)

export default component.exports